import UploadCsvModal from '../upload-csv-modal'
import { Upload } from '../../services/api/upload'

const UploadFleetModal = ({ visible, onCancel, onComplete }) => {
	return (
		<UploadCsvModal
			title='Upload Fleet'
			type='fleet'
			fields={[
				{ label: 'ID', key: 'id', type: 'string' },
				{ label: 'Model', key: 'model', type: 'string' },
				{ label: 'Brand', key: 'brand', type: 'string' },
				{ label: 'Type', key: 'type', type: 'string' },
				{ label: 'Year', key: 'year', type: 'string' },
				{ label: 'Plate Number', key: 'plateNumber', type: 'string' },
				{ label: 'Tracker\'s Manufacturer', key: 'trackerManufacturer', type: 'string' },
				{ label: 'Tracker\'s Model', key: 'trackerModel', type: 'string' },
				{ label: 'Tracker\'s IMEI', key: 'trackerImei', type: 'string' },
				{ label: 'Tracker\'s SIM Card Number', key: 'trackerSimCardNumber', type: 'string' },
				{ label: 'Internal ID', key: 'internalId', type: 'string' }
			]}
			firstStepPrompt='Download the CSV file containing all the data related to your fleet.'
			secondStepPrompt='Edit the CSV file by adding new rows and editing existing rows. Rows without a value in the ID column will be created while rows with an ID will update the vehicle.'
			visible={visible}
			onCancel={onCancel}
			onComplete={onComplete}
			downloadTask={Upload.downloadVehiclesCsv}
			uploadTask={Upload.uploadVehiclesCsv}
		/>
	)
}

export default UploadFleetModal
